/** *
 接口文档地址 https://shop-dev.vzan.com/swagger/index.html#/
 ***/
import { getToken } from '../../../utils'
import { get, post, getStore, postStore } from '@/utils/http/http'
import qs from 'qs'
import {
  SHOP_URL,
  FIXUP_URL,
  HOMEMINIURI,
  MARKET_URL,
  LIVE_GW_URL,
} from '@/utils/http/baseUrl'
import StoreController from '@/controllers/storeController/view/store/store.controller.js'
import StoreApiController from '@/controllers/storeController/view/store/storeApi.controller.js'

const base = SHOP_URL
const sVideo = FIXUP_URL

export const $shopApi = {
  /**
   * @method 获取店铺信息(获取店铺首页数据，含店铺信息，商品分类及旧版店铺优惠券)
   * @param {integer} zbId 直播间Id
   * @param {boolean} isSelCoupon 查店铺优惠券为true
   */
  getStoreIndex: params => post(`${base}/api/store/index`, params),

  /**
   * @method 获取新版店铺优惠券（商城推广）
   * @param {integer} zbId 直播间Id
   * @param {integer} page
   * @param {integer} psize
   */
  getStoreCouponList: params =>
    post(`${MARKET_URL}/api/v1/coupon/GetStoreCouponList`, params, false),

  /**
   * @method 新版店铺优惠券分享链接时新增一条邀请记录
   * @param {integer} zbid 直播间Id
   * @param {integer} type //邀请类型 ，店铺首页分享：0，商品详情分享：1
   * @param {integer} itemId  //商品详情页分享时传【商品id】,店铺首页分享不传或传0
   * @param {integer} shareUserId //分享人用户id
   */
  AddInvitationRecord: params =>
    post(`${MARKET_URL}/api/v1/coupon/AddInvitationRecord`, params),

  /**
   * @method 获取店铺信息
   * @param {integer} zbId 直播间Id
   */
  getStoreDetail: params => post(`${base}/api/store/detail`, params),

  /**
   * @method 获取商品列表
   * @param {integer} zbId 直播间Id
   * @param {integer} topicId 话题Id
   * @param {integer} classId 分类ID
   * @param {integer} state 商品状态；0：已下架，1：上架
   * @param {integer} mode 商品类型
   * @param {string} nameOrId 商品名称或ID
   * @param {string} sort 排序字段
   * @param {string} orderby 排序字段升序或降序；'desc'：降序，'asc'：升序
   * @param {integer} PageIndex
   * @param {integer} PageSize
   */
  getProList: params => post(`${base}/api/product/list`, params, true),

  /**
   * @method 获取商品详情
   * @param {integer} proId 商品id
   */
  getProDetail: params =>
    post(`${base}/api/product/getproductinfo?v=` + Math.random(), params),

  /**
   * @method 获取限时折扣信息
   * @param {integer} zbId 直播间Id
   * @param {integer} topicId 话题Id
   * @param {array} commodityIds 商品ids
   */
  getlistbycommodity: params =>
    post(`${base}/api/limitdiscounts/getlistbycommodity`, params, false),

  // 微信端满减活动推广信息
  getPromotion: params =>
    get(
      `${base}/api/v1/wx/fullreduction/getwxpromotedata?actId=${params.actId}`
    ),

  // 获取购物车数量
  getCartCount: params =>
    post(`${base}/api/ProductCart/GetUserCartCount`, params),

  /**
   * @method 获取满减满折信息
   * @param {integer} zbId 直播间Id
   * @param {array} proIds 商品ids
   */
  getFullReduction: params =>
    post(`${base}/api/fullreduction/getfullreductionlist`, params, false),
  /**
   * @method 加入购物车查询详情
   */
  getGoodsDetial: params =>
    post(`${base}/api/product/getproductinfo?v=` + Math.random(), params),

  /**
   * @method 用户购物车商品满减活动指导
   */
  getpreviewdatafromcart: params =>
    post(
      `${base}/api/v1/wx/fullreduction/getpreviewdatafromcart?actId=${params.actId}`
    ),

  /**
   * @method 获取推广页的商品列表
   *
   */
  getPromotionShopList: params =>
    post(`${base}/api/v1/wx/fullreduction/getactivityproducts`, params, false),
  getGoodsSku: params => post(`${base}/api/product/getproductinfo`, params),
  addGoodscart: params =>
    post(`${base}/api/productcart/addproductcart`, params),
  /**
   * @method 购物车列表
   * @param {integer} zbId 直播间Id
   */
  getproductcartlist: params =>
    get(
      `${base}/api/productcart/getproductcartlist`,
      Object.assign(params),
      false
    ),

  /**
   * @method 购物车修改SKU
   * @param {integer}
   */
  setskubyprocart: params =>
    post(`${base}/api/productcart/setskubyprocart`, params),

  /**
   * @method 更改购物车商品数量
   * @param {integer} cartId 购物车ID
   * @param {integer} amount 数量，如果是减少则传递负数
   * @param {integer} skuId 规格ID
   */
  setamountproductcart: params =>
    post(`${base}/api/productcart/setamountproductcart`, params, true, {
      allRes: true,
    }),

  /**
   * @method 删除购物车（单个或批量）
   * @param {integer} zbId 直播间Id
   * @param {string} cartIds 购物车ID
   */
  getproducdeleteproductcarttcartlist: params =>
    post(
      `${base}/api/productcart/getproducdeleteproductcarttcartlist`,
      params,
      false
    ),

  /**
   * @method 获取话题商品
   * @param {integer} zbId 直播间Id
   * @param {integer} tpId 话题Id
   * @param {integer} pageIndex
   * @param {integer} pageSize
   */
  gettopicproductlist: params =>
    post(`${base}/api/productmanage/topic_ctproducts`, params, false),

  /**
   * @method 获取话题选择增加的商品列表
   * @param {integer} zbId 直播间Id
   * @param {integer} topicId 话题Id
   * @param {string} keyWord 搜索关键字
   * @param {integer} state 上下架 0：已下架，1：上架
   * @param {integer} types 商品类型 全部-2
   * @param {integer} pageIndex
   * @param {integer} pageSize
   */
  gettopicselprolist: params =>
    post(`${base}/api/productmanage/gettopicselprolist`, params, false),

  /**
   * @method 移除话题关联商品
   * @param {integer} topicId 话题Id
   * @param {array<integer>} proIds 商品id
   */
  deleteassociatedpro: params =>
    post(`${base}/api/productmanage/deleteassociatedpro`, params),

  /**
   * @method 设置话题商品(横屏)
   * @param {integer} topicId 话题Id
   * @param {array<integer>} proIds 商品id
   * @param {string} tabId defaukt--"Eleven"
   * @param {integer} menuId //非必填
   * @param {string} menuName //非必填
   */
  settopicproduct: params =>
    post(`${base}/api/productmanage/settopicctproduct`, params),

  /**
   * @method 设置话题商品(竖屏)
   * @param {integer} topicId 话题Id
   * @param {array<integer>} proIds 商品id
   */
  verticalsavetopicpro: params =>
    post(`${base}/api/productmanage/verticalsavetopicpro`, params),

  /**
   * @method 购物车提交订单
   * @param {integer} orderInfo 购物车id
   */
  suborder: params => post(`/liveajax/suborder`, qs.stringify(params)),

  /**
   * @method 获取连锁版门店详情
   * @param {integer} shopId 门店id
   */
  GetShopInfo: params => get('/liveajax/GetShopInfo', params),

  /**
   * @method 获取小视频详情
   * @param {String} tpId 话题Id
   */
  getSmallVideoInfo: param =>
    get(`${sVideo}/api/v1/wx/topic/get_topic_hlsurl?topicId=${param}`),

  /**
   * @method 获取招募商品列表
   * @param {Number} zbid 直播Id
   * @param {Number} shopId 门店id
   */
  RecruitingNeedProductLs: param =>
    post(
      `${HOMEMINIURI}/api/Generalize/RecruitingNeedProductLs`,
      qs.stringify(param)
    ),

  /**
   * @method 获取招募商品列表
   * @param {Number} zbid 直播Id
   * @param {Number} generalizeShopId 门店id
   */
  Generalizerule: param =>
    get(`${HOMEMINIURI}/api/Generalize/Generalizerule`, param),

  getGeneralizeManStatus: param =>
    get(`${HOMEMINIURI}/api/Generalize/SalesmanStatus`, param),

  /**
   * @method 获取底部导航
   * @param {String} tpId 话题Id
   */
  getBottomnavigaList: params =>
    get(`${sVideo}/api/v1/wx/indextemplate/get_bottomnaviga_list`, params),
  getBottomnavigaInfo: params =>
    get(`${sVideo}/api/v1/wx/indextemplate/get_bottomnaviga_info`, params),

  // 添加门店访问记录
  Visit: param =>
    post(`${HOMEMINIURI}/api/ChainStore/Visit`, qs.stringify(param), false, {
      ContentType: 'application/x-www-form-urlencoded;charset=UTF-8',
    }),

  getPaySuccessDetail: (params, showLoading = true) =>
    get(`${SHOP_URL}/api/biorder/pay_success_info`, params, showLoading),
  postVerifyTickets: params =>
    post(`${SHOP_URL}/api/v1/wx/verify/verify_records`, params),
  getGroupInfo: params =>
    get(`${SHOP_URL}/api/store/get_store_drainage_info`, params),

  getMallInfo: params => post(`${SHOP_URL}/api/v2/product/mall_info`, params),
  getPrivateDetail: params =>
    post(`/marketing/wx/v1/public/private_domain/drainage/detail`, params),
  postGeneralizeCustom: params =>
    post(`${HOMEMINIURI}/api/Generalize/Custom`, params),

  // 后台获取店铺风格信息
  getStoreStyleInfo: (zbid, type) =>
    get(
      `${sVideo}/api/v1/siteinfo/get_site_attribute_value_cache?zbid=${zbid}&type=${type}`,
      null
    ),
  get_site_attribute_value_cache: (zbid, type) =>
    get(
      `${sVideo}/api/v1/siteinfo/get_site_attribute_value_cache?zbid=${zbid}&type=${type}`,
      null
    ),
  get_leadenter_switch: params =>
    get(
      `${FIXUP_URL}/api/v1/memberlevel/SiteInfo/get_leadenter_switch`,
      params
    ),
  // 获取实物商品
  getProduct: params => {
    const isStore = StoreController.isStore()
    const $apiPost = isStore ? postStore : post
    return $apiPost(`${SHOP_URL}/api/productmanage/products`, params, false, {
      headers: {
        lid: window.zbvd.zbid,
        Authorization: `Bearer ${getToken()}`,
        uid: $.cookie('liveticket'),
      },
    })
  },

  // 获取直播
  getTopicList: params =>
    post(`${FIXUP_URL}/api/v1/topic/get_topicdatas`, params, false, {
      headers: {
        lid: window.zbvd.zbid,
        Authorization: `Bearer ${getToken()}`,
        uid: $.cookie('liveticket'),
      },
    }),

  // 获取频道
  getChannelList: params =>
    post(`${FIXUP_URL}/api/v1/channel/get_channeldatas_h5`, params, false, {
      headers: { lid: window.zbvd.zbid, Authorization: `Bearer ${getToken()}` },
    }),

  // 获取图文
  getPictureList: params =>
    post(
      `${LIVE_GW_URL}/train/v1/admin/content/good/picture/list`,
      params,
      false,
      {
        headers: {
          lid: window.zbvd.zbid,
          Authorization: `Bearer ${getToken()}`,
        },
      }
    ),

  // 获取音频
  getAudioList: params =>
    post(
      `${LIVE_GW_URL}/train/v1/admin/content/good/audio/list`,
      params,
      false,
      {
        headers: {
          lid: window.zbvd.zbid,
          Authorization: `Bearer ${getToken()}`,
        },
      }
    ),

  // 获取视频
  getVideoList: params =>
    post(
      `${LIVE_GW_URL}/train/v1/admin/content/good/video/list`,
      params,
      false,
      {
        headers: {
          lid: window.zbvd.zbid,
          Authorization: `Bearer ${getToken()}`,
        },
      }
    ),

  // 获取课程
  getCourseList: params =>
    post(
      `${LIVE_GW_URL}/train/v1/admin/content/good/course/list`,
      params,
      false,
      {
        headers: {
          lid: window.zbvd.zbid,
          Authorization: `Bearer ${getToken()}`,
        },
      }
    ),

  // 获取专栏
  getSpecialList: params =>
    post(
      `${LIVE_GW_URL}/train/v1/admin/content/good/special_topic/list`,
      params,
      false,
      {
        headers: {
          lid: window.zbvd.zbid,
          Authorization: `Bearer ${getToken()}`,
        },
      }
    ),

  // 获取训练营
  getTrainingList: params =>
    post(
      `${LIVE_GW_URL}/train/v1/admin/content/good/training/list`,
      params,
      false,
      {
        headers: {
          lid: window.zbvd.zbid,
          Authorization: `Bearer ${getToken()}`,
        },
      }
    ),

  // 获取权益卡
  getCardmemberList: params =>
    get(
      `${MARKET_URL}/api/v1/cardmember/get_cardmember_list_h5`,
      params,
      false,
      {
        headers: {
          lid: window.zbvd.zbid,
          Authorization: `Bearer ${getToken()}`,
        },
      }
    ),
  /**
   * @method 已绑定话题的商品id
   */
  getTopicProductIdList: params =>
    get(`${base}/api/productmanage/topic_ctbinded_ids`, params, false),

  /**
   * @method 购物车结算
   */
  postCartBalanceorder: params =>
    post(`${base}/api/productcart/cartbalanceorder`, params, false, {
      allRes: 1,
    }),
  isNewShopCart: params =>
    get(`${base}/api/productcart/isnewproductcart`, params, false),
  /**
   *
   * @method 设置换促销类型
   * @param discountType '-1-原价，1-限时折扣价 2-会员价'
   * @param zbId
   * @param cardId
   */
  setdiscountbyprocart: params =>
    post(`${base}/api/productcart/setdiscountbyprocart`, params),

  /**
   *
   * @method 物流公司
   *
   */
  expresscompanies: params =>
    get(`${base}/api/productmanage/expresscompanies`, params),

  /**
   *
   * @method 计算商品运费
   *
   */
  computeProductShipping: params =>
    post(`${base}/api/v2/product/compute_product_shipping`, params, false, {
      allResolve: true,
    }),

  /**
   *
   * @method 代理-商品统计-获取最近N个搜索商品
   *
   */
  getLatestSearchProducts: params => {
    const isStore = StoreController.isStore()
    const $apiPost = isStore ? getStore : get
    return $apiPost(
      `${LIVE_GW_URL}/health/v1/h5/agent-data/getLatestSearchProducts`,
      params
    )
  },

  // 获取店铺隔开配置
  getMallConfig: params =>
    get(`${SHOP_URL}/api/v2/product/mall_config`, params),
  /** 获取店铺分类 */
  getSelfGroupList: params =>
    post(`${SHOP_URL}/api/selftakestoremng/group_list`, params),
  // 获取可选定位地区
  getSelfTakeStoreArea: params =>
    get(`${SHOP_URL}/api/selftakestoremng/getselftakestorearea`, params),
  // 根据经纬度获取省市区
  getLocationAnalysis: params =>
    get(`${LIVE_GW_URL}/health/v1/h5/store/manager/locationAnalysis`, params),
  // 修改快递信息
  changeDeliveryInfo: params =>
    post(`${SHOP_URL}/api/order/updaterefundorderlogistics`, params),
  /** 购物车所在区域无货 */
  getProductsAreaState: params =>
    post(`${LIVE_GW_URL}/shop/v3/H5/shop/product/getProductsAreaState`, params),

  // H5端获取用户自主核销配置
  getSelfVerifyConfig: params =>
    get(`${SHOP_URL}/api/v1/wx/verify/get_self_verify_config`, params),

  // 设置门店自主核销开关
  setSelfTakeStoreSelfVerify: params =>
    post(`${SHOP_URL}/api/SelfTakeStoreMng/SetSelfTakeStoreSelfVerify`, params),

  // 获取未核销商品的门店
  getSelfVerifyStoreList: params =>
    get(`${SHOP_URL}/api/v1/wx/verify/get_self_verify_store_list`, params),

  // 商品排序
  setProductSort: params =>
    post(`${SHOP_URL}/api/product/topicprodragsort`, params),

  // 获取积分商品
  getIntegralGoods: params =>
    post(`${LIVE_GW_URL}/integral/v1/h5/activity/listIntegralActivity`, params),
}
